import React, { useEffect, useState } from 'react';
const memo = {};
/** null = unknown/loading, true = bookable, false = listener can't take bookings yet. */
export const useListenerReady = listingId => {
  const [ready, setReady] = useState(listingId && memo[listingId] ? memo[listingId].ready : null);
  useEffect(() => {
    if (!listingId || typeof window === 'undefined') return undefined;
    let live = true;
    fetch(`/api/listener-ready/${listingId}`, { credentials: 'include' })
      .then(r => (r.ok ? r.json() : { ready: true }))
      .then(b => {
        memo[listingId] = b;
        if (live) setReady(b.ready !== false);
      })
      .catch(() => live && setReady(true));
    return () => {
      live = false;
    };
  }, [listingId]);
  return ready;
};
export const ListenerNotReady = () => (
  <div role="status" data-listener-not-ready="true" style={{ padding: '16px', borderRadius: 12, background: '#FFF6E5', color: '#5A3E00', lineHeight: 1.45 }}>
    <strong>This listener isn’t taking bookings yet.</strong>
    <div>They’re still finishing their setup. Please pick another listener.</div>
    <a href="/s?mode=listeners" style={{ display: 'inline-block', marginTop: 8, fontWeight: 700 }}>Meet our listeners →</a>
  </div>
);
